import { render, staticRenderFns } from "./choicePeopleConsortium.vue?vue&type=template&id=178201b2&scoped=true&"
import script from "./choicePeopleConsortium.vue?vue&type=script&lang=js&"
export * from "./choicePeopleConsortium.vue?vue&type=script&lang=js&"
import style0 from "./choicePeopleConsortium.vue?vue&type=style&index=0&lang=css&"
import style1 from "./choicePeopleConsortium.vue?vue&type=style&index=1&id=178201b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178201b2",
  null
  
)

export default component.exports